import { render, staticRenderFns } from "./AgencyStatusChip.vue?vue&type=template&id=32b457ec&scoped=true"
import script from "./AgencyStatusChip.vue?vue&type=script&lang=js"
export * from "./AgencyStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b457ec",
  null
  
)

export default component.exports